<div class="flex w-full py-3.5 items-center px-6 title font-main text-3xl font-bold text-navy-90 border-b border-navy-30">
  {{ buildTranslationKey('header') | translate }}
</div>

<div class="w-full h-full overflow-x-hidden overflow-y-auto pt-4 pb-6 px-6">
  <div class="flex w-full flex-col gap-6.5 max-w-175">
    <app-access-time-limitation class="time-limitation"></app-access-time-limitation>

    <div class="h-px bg-navy-40"></div>

    <app-salesforce-automatic-approvals class="salesforce-automatic-approvals"></app-salesforce-automatic-approvals>
  </div>
</div>

